"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFeatureEnabled = void 0;
var isVersionSupported_1 = require("./isVersionSupported");
function isFeatureEnabled(props) {
    var _a;
    var filteredFeatureFlags = ((_a = props.featureFlags) === null || _a === void 0 ? void 0 : _a.filter(function (flag) { return flag.name === props.featureName; })) || [];
    // A feature is always enabled, when it's not inside features.
    // On This way, we can just delete the feature flag, as soon as it's 100% rolled out.
    if (filteredFeatureFlags.length === 0)
        return true;
    for (var _i = 0, filteredFeatureFlags_1 = filteredFeatureFlags; _i < filteredFeatureFlags_1.length; _i++) {
        var featureFlag = filteredFeatureFlags_1[_i];
        if (props.userGroup === undefined ||
            props.userGroup < featureFlag.from ||
            props.userGroup >= featureFlag.to) {
            continue;
        }
        if (props.currentVersion !== undefined &&
            featureFlag.minVersion !== undefined &&
            !isVersionSupported_1.isVersionSupported(featureFlag.minVersion, props.currentVersion)) {
            continue;
        }
        // If there are no country IDs, then the feature is for all countries.
        if (!featureFlag.countryIds) {
            return true;
        }
        // If the current country ID is inside the feature country IDs, then it's enabled.
        if (props.currentCountryId &&
            featureFlag.countryIds.includes(props.currentCountryId)) {
            return true;
        }
    }
    return false;
}
exports.isFeatureEnabled = isFeatureEnabled;
